// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2391":"332f43bb4d43fe65","2888":"11acd35cdfef0852","7516":"c198c4bfa6dd2364"}[chunkId] + ".css";
};